import React, { Component } from "react";

import LocalizedStrings from "react-localization";
import en from "../../localization/localization-en.json";

import { renderErrorMessage } from "../../helper/user_helper";

import ReactPhoneInput from "react-phone-input-2";
import { isValidNumber } from "libphonenumber-js";
import Loader from "../loader";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

let strings = new LocalizedStrings({ en });

class UserProfileEdit extends Component {
  state = {};

  constructor(props) {
    super(props);
    const first_name = this.props.user.first_name;
    const last_name = this.props.user.last_name;
    const username = this.props.user.username;
    const phone_number = this.props.user.phone_number;
    const image_url_medium = this.props.user.image_url_medium;
    const imageFile = null;
    const errors = "";
    this.state = {
      username,
      image_url_medium,
      imageFile,
      first_name,
      phone_number,
      last_name,
      errors
    };
  }

  render() {
    const imageLabel = { cursor: "pointer" };
    return (
      <div className="profilePage center">
        <div className="edit_logout cursor_btn">
          <div className="right">
            <FontAwesomeIcon
              className="yaystack_icon_navBar yaystack_color mr-3"
              icon={faTimes}
              onClick={this.props.handlerEdit}
            />
          </div>
        </div>
        <form onSubmit={this.updateUserInfo} className="max_width_300">
          <div className="image-profile-edit-div mt-4">
            <label
              style={imageLabel}
              className="yaystack_input_text_label mt-1"
              htmlFor="image-upload"
            >
              <img
                htmlFor="image-upload"
                src={this.state.image_url_medium}
                className="image-profile image-profile-edit"
                alt="profile"
              />
            </label>
            <input
              type="file"
              className="input-file"
              // capture="camera"
              accept="image/*"
              id="image-upload"
              name="image-upload"
              onChange={this.handleChangeImage}
            />
          </div>

          <br />
          <label className="yaystack_input_text_label">
            {strings.first_name}
            <input
              className="yaystack_input_text mb-3"
              type="text"
              required={true}
              value={this.state.first_name}
              placeholder={strings.first_name}
              onChange={this.handleChangeFirstName}
            />
          </label>
          <br />
          <label className="yaystack_input_text_label">
            {strings.last_name}
            <input
              className="yaystack_input_text mb-3"
              type="text"
              required={true}
              value={this.state.last_name}
              placeholder={strings.last_name}
              onChange={this.handleChangeLastName}
            />
          </label>
          <br />
          <label className="yaystack_input_text_label">
            {strings.username}
            <input
              className="yaystack_input_text mb-3"
              type="text"
              required={true}
              value={this.state.username}
              placeholder={strings.username}
              onChange={this.handleChangeUsername}
              autoCapitalize="none"
            />
          </label>
          <br />
          <label>
            {strings.phone_number}
            <ReactPhoneInput
              className="yaystack_input_text mb-3"
              defaultCountry={"us"}
              value={this.state.phone_number}
              onChange={value => this.setState({ phone_number: value })}
            />
          </label>
          {renderErrorMessage(this.props.errors)}
          {renderErrorMessage(this.state.errors)}
          {this.renderSubmitButton()}
        </form>
      </div>
    );
  }

  renderSubmitButton() {
    if (this.props.loaded === false) {
      return <Loader loaded={this.props.loaded} />;
    }
    return (
      <input
        type="submit"
        value={strings.save}
        className="btn btn_primary btn_yaystack mb-2 mt-1 width_100"
      />
    );
  }

  handleChangeUsername = event => {
    const username = event.target.value.toLowerCase();
    this.setState({ username });
  };

  handleChangeFirstName = event => {
    this.setState({ first_name: event.target.value });
  };

  handleChangeLastName = event => {
    this.setState({ last_name: event.target.value });
  };

  handleChangePhoneNumber = event => {
    this.setState({ phone_number: event.target.value });
  };

  handleChangeImage = event => {
    if (event.target.files && event.target.files[0]) {
      let reader = new FileReader();
      reader.onload = e => {
        this.setState({
          image_url_medium: e.target.result
        });
      };
      this.setState({ imageFile: event.target.files[0] });
      reader.readAsDataURL(event.target.files[0]);
    }
  };

  updateUserInfo = event => {
    let errors = "";
    this.setState({ errors });
    event.preventDefault();
    if (!this.state.phone_number) {
      this.setState({ phone_number: "" });
    } else if (this.state.phone_number === "+") {
      this.setState({ phone_number: "" });
    } else if (!isValidNumber(this.state.phone_number)) {
      let errors = "Wrong Phone Number";
      this.setState({ errors });
      return;
    }
    var fd = new FormData();
    fd.append("user[username]", this.state.username);
    fd.append("user[first_name]", this.state.first_name);
    fd.append("user[last_name]", this.state.last_name);
    fd.append("user[phone_number]", this.state.phone_number);
    if (this.state.imageFile !== null) {
      fd.append("user[avatar]", this.state.imageFile);
    }
    this.props.handlerSave(fd);
  };
}

export default UserProfileEdit;



// WEBPACK FOOTER //
// ./src/components/profile/user_profile_edit.jsx